import { render, staticRenderFns } from "./Cables.vue?vue&type=template&id=35f2f4f9&"
import script from "./Cables.vue?vue&type=script&lang=js&"
export * from "./Cables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports